/**
 * 기술 분류 DB 목록 → 화면의 코드 목록에 반영(2026-11-05 · 「기술 분류」 탭).
 *
 * 27코드 · 이름 · 설명은 코드 파일(partnerTechCodes.ts · techMaster.ts)에 있고 여러 화면이 바로 쓴다.
 *   그 화면들을 고치지 않고, 로그인한 뒤 한 번 DB 목록을 읽어 같은 배열 · Map 에 제자리 반영한다
 *   (새 코드 추가 · 이름 · 설명 · 그룹 · 사용 여부 · 사람이 더한 별칭).
 *   DB 표가 없거나 못 읽으면 코드 파일 목록 그대로 — 화면은 그대로 열린다.
 *   반영 전에 그려진 화면은 다음에 열 때 새 값을 본다(목록이 바뀌는 일은 드물다).
 */
import { fetchTechCategories, type TechCategoriesResponse } from "../../automation/equipmentCatalog/catalogApi";
import { applyPartnerTechCodes } from "./partnerTechCodes";
import { syncTechMaster } from "../techMaster";

let loaded: Promise<void> | null = null;

/** 응답을 화면 목록에 반영(관리 화면이 고친 뒤에도 부른다) */
export function applyTechCategoryResponse(r: TechCategoriesResponse | null | undefined) {
  if (!r || r.storage !== "db" || !Array.isArray(r.categories) || !r.categories.length) return;
  applyPartnerTechCodes(r.categories.map((c) => ({ code: c.code, group: c.group, name: c.name, description: c.description, active: c.active })));
  syncTechMaster(Object.fromEntries(r.categories.map((c) => [c.code, c.manual_aliases || []])));
}

/** 로그인 뒤 한 번 — 실패해도 조용히(코드 파일 목록 그대로) */
export function loadTechCategoryRegistry(): Promise<void> {
  if (!loaded) {
    loaded = fetchTechCategories().then(applyTechCategoryResponse).catch(() => { loaded = null; });
  }
  return loaded;
}
